import api from './api'

const userDataProvider = {
  getUserDetails(params = {}) {
    return api.query('People/api/People/PeopleInfo', { params })
  },
  addNewUser(params) {
    return api.post('People/api/People', params)
  },
  getProvinceList(params = {}) {
    return api.query('Region/api/City/GetAllProvinces', { params })
  },
  getCityList(params = {}) {
    return api.query('Region/api/City/GetProvinceAllCities', { params })
  },
  getUserProfileMenuItems() {
    return api.get('Aggregator.Crm/api/Table/GetProfileMenu')
  },
  getUserProfileItemsData(payload, params = {}) {
    return api.post(payload, params)
  },
  removeTag(params = {}) {
    return api.query('People/api/People/RemoveTag', { params })
  },
  addTag(params = {}) {
    return api.query('People/api/People/AddTag', { params })
  },
  updateRate(params = {}) {
    return api.put('People/api/People/SetSatisfactionRate', params)
  },
  updateImage(params = {}) {
    return api.put('People/api/People/UpdateAvatarImage', params)
  },
  updateAdminNote(params = {}) {
    return api.put('People/api/People/UpdateAdminNote', params)
  },
  addAddress(params) {
    return api.post('Shipping/api/Address/AddAddressFromAdmin', params)
  },
  getUserOrders(params = {}){
    return api.post('Ordering/api/AdminOrder/UserOrder',params)
  },
  getUserList(params = {}){
    return api.post('crmtt/api/Issue/UserList',params)
  }
}

export default userDataProvider
